export enum StatsDisplayMode {
  HOURS = 'hours',
  COST = 'cost',
}
